module.exports = __webpack_public_path__ + "22c2b2e4affd7c02d0a758c6c856fc0b.png";